export enum GoogleGeoCoderType {
    Route = 'route',
    StreetNumber = 'street_number',
    PostalCode = 'postal_code',
    Locality = 'locality',
}
